<template>
    <div>
        <Dialog v-model:visible="displayDialog" :style="{width: '55vw'}" :closable="false">
            <template #header>
                <h4 class="p-pt-3">Busqueda de equipos</h4>
            </template>
                
            <DataTable
            :value="equipos"
            dataKey="Id_equipo_tabla"
            ref="dt"
            v-model:filters="filters"
            :globalFilterFields="['MAC','NUM_SERIE','IP','MARCA','MODELO','UNIDAD','TIPO']"
            :loading="loading"
            responsiveLayout="scroll"
            scrollHeight="70vh"
            :paginator="true"
            :rows="30"
            v-model:selection="equiposSeleccionados"
            >
                <template #header>
                    <div class="table-header w-full grid">
                    <div class="col-3 flex align-items-center">
                        <span class="text-2xl">Equipos</span>
                    </div>
                    <div class="p-field col-4">
                        <Dropdown v-if="unidadesMantenimiento" class="w-full"
                            v-model="unidadSeleccionada"
                            :options="listUnidadesFromMantenimiento"
                            optionLabel="Unidad"
                            placeholder="Selecciona una unidad"
                            :filter="true"
                            @change="cargarUniverso"
                        />
                        <Dropdown v-else class="w-full"
                            v-model="unidadSeleccionada"
                            :options="lstUnidadesFromServer"
                            optionLabel="UNIDAD_SUBRED"
                            placeholder="Selecciona una unidad"
                            :filter="true"
                            @change="cargarUniverso"
                        />
                        </div>
                        <div class="p-field col-2">
                            <!-- <label for="tipo">Tipo</label> -->
                            <Dropdown
                                id="tipo"
                                appendTo="body"
                                v-model="tipoSeleccionado"
                                :options="lstTipos"
                                optionLabel="Descripcion"
                                placeholder="Selecciona un tipo o escribe uno nuevo"
                                dataKey="Id_tipo_dispositivo"
                                @change="cargarUniverso"
                            />
                        </div>
                        <div class="col-3 flex justify-content-end">
                            <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText type="text" v-model="filters['global'].value"  placeholder="Buscar..."/>
                            </span>
                        </div>
                    </div>
                </template>
                <template #empty> No se encontrarón registros. </template>
                <template #loading> Cargando datos. Espere por favor. </template>
                <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                <Column field="UNIDAD" header="UNIDAD" sortable></Column>
                <Column field="TIPO" header="TIPO" sortable></Column>
                <Column field="MARCA" header="MARCA" sortable></Column>
                <Column field="MODELO" header="MODELO" sortable></Column>
                <Column field="IP" header="IP" sortable></Column>
                <Column field="MAC" header="MAC" sortable></Column>
                <Column field="NUM_SERIE" header="Número de serie" sortable></Column>
                <template #footer>
                    Registros en total {{ equipos ? equipos.length : 0 }}
                </template>
            </DataTable>

            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cerrarDialogo()" />
                <Button label="Aceptar" icon="pi pi-check" @click="aceptarSeleccion()"/>
            </template>
        </Dialog>
    </div>
</template>
<script>
import ServicioInventario from "../service/Inventario";
import ServicioUnidades from "../service/Unidades";
import TiposDispositivos from "../service/Tipos_dispositivos";
import {FilterMatchMode} from 'primevue/api';

export default {
    props: {
        displayComponent : Boolean,
        unidadesComponent : Array,
        unidadesMantenimiento : Array
    },
    emits: ['onSelect','onClose'],
    data(){
        return{
            displayDialog: false,
            equipos : [],
            equiposSeleccionados : [],
            lstUnidadesFromServer : [],
            listUnidadesFromMantenimiento : [],
            lstTipos : [],
            tipoSeleccionado : null,
            unidadSeleccionada : null,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            loading: false,
        }
    },
    created(){
        // this.getEquiposFromUniverso();
    },
    mounted(){
        this.cargaInicial();
    },
    watch: {
        displayComponent(newvalue){
            if(!newvalue){
                this.equiposSeleccionados = [];
            }
            this.displayDialog = newvalue;
            if(this.listUnidadesFromMantenimiento?.length == 1){
                    this.unidadSeleccionada = this.listUnidadesFromMantenimiento[0];
                    this.cargarUniverso();
            }
        },
        unidadesMantenimiento(newvalue){
            if(newvalue){
                this.getUnidadesInventarioFromMantenimiento();
            }
        },
    },  
    methods:{
        cargarUniverso(){
            var t = this;
            let servicioInventario = new ServicioInventario();
            servicioInventario.getUniversoEquipos(t,t.unidadSeleccionada?.Unidad,t.tipoSeleccionado?.Id_tipo_dispositivo).then((res) => {
                t.loading = false;
                t.equipos = res;
                t.equipos.forEach(element => {
                    element.Id_equipo_tabla = `${element.Id_equipo}_${element.Catalogo}`;
                });
            });
        },
        cargaInicial() {
            var t = this;
            
            if(!t.unidadesMantenimiento){
                let servicioInventario = new ServicioInventario();
                servicioInventario.getUnidades(t).then((res) => {
                    t.lstUnidadesFromServer = res;
                    t.lstUnidadesFromServer.unshift({
                    UNIDAD: "TODOS",
                    SUBRED: "TODOS",
                    UNIDAD_SUBRED: "TODOS",
                    });
    
                    t.unidadSeleccionada = {
                    UNIDAD: "TODOS",
                    SUBRED: "TODOS",
                    UNIDAD_SUBRED: "TODOS",
                    };
    
                }).then(() => {
                    // t.getEquiposFromUniverso();
                });
            }

            t.getTipoFromUniverso();

        },
        cerrarDialogo(){
            this.$emit('onClose');
        },
        aceptarSeleccion(){
            this.$emit('onSelect',this.equiposSeleccionados);
        },
        getTipoFromUniverso(){
            let t = this;
            let tiposDispisitivos = new TiposDispositivos();
            tiposDispisitivos.getDispositivos(t).then((res) => {
                    t.lstTipos = res;
                    t.lstTipos.unshift({
                        Id_tipo_dispositivo : -1,
                        Descripcion: "TODOS",
                    });

                    t.tipoSeleccionado = {
                        Id_tipo_dispositivo : -1,
                        Descripcion: "TODOS",
                    };

                    // t.cargarUniverso();
            });
        },
        getUnidadesInventarioFromMantenimiento(){
            let t = this;
            if(t.unidadesMantenimiento?.length){
                let servicioUnidades =  new ServicioUnidades();
                servicioUnidades.getUnidadesInventarioFromMantenimiento(t,t.unidadesMantenimiento).then(res => {
                    if(res){
                        this.listUnidadesFromMantenimiento = res;
                    }
                });
            }
        }
    }
}
</script>